export default [
  {
    key: 0,
    text: 'Vehicle.make',
    value: '{{vehicle.make}}'
  },
  {
    key: 1,
    text: 'Vehicle.trim',
    value: '{{vehicle.trim}}'
  },
  {
    key: 2,
    text: 'Vehicle.dealer_name',
    value: '{{vehicle.dealer_name}}'
  },
  {
    key: 3,
    text: 'Vehicle.price',
    value: '{{vehicle.price}}'
  },
  {
    key: 4,
    text: 'Vehicle.model',
    value: '{{vehicle.model}}'
  },
  {
    key: 5,
    text: 'Vehicle.body_style',
    value: '{{vehicle.body_style}}'
  },
  {
    key: 6,
    text: 'Vehicle.custom_label_0',
    value: '{{vehicle.custom_label_0}}'
  },
  {
    key: 7,
    text: 'Vehicle.description',
    value: '{{vehicle.description}}'
  },
  {
    key: 8,
    text: 'Vehicle.exterior_color',
    value: '{{vehicle.exterior_color}}'
  },
  {
    key: 9,
    text: 'Vehicle.sale_price',
    value: '{{vehicle.sale_price}}'
  },
  {
    key: 10,
    text: 'Vehicle.title',
    value: '{{vehicle.title}}'
  },
  {
    key: 11,
    text: 'Vehicle.url',
    value: '{{vehicle.url}}'
  },
  {
    key: 12,
    text: 'Vehicle.vin',
    value: '{{vehicle.vin}}'
  },
  {
    key: 13,
    text: 'Vehicle.year',
    value: '{{vehicle.year}}'
  }
];



// WEBPACK FOOTER //
// ./src/components/common/DescriptionVariables.js